import { Button } from "antd"
import { loginInfo } from "../../api"
import { useEffect } from "react"

const Home = ()=>{
    const test = async ()=>{
         const{data}  = await loginInfo()
         console.log("获取的登录信息是：",data)
    }
    return <div>
        <h1>主页</h1>
        <Button type="primary" onClick={test}>获取登录信息测试</Button>
    </div>
}
export default Home
